import*as o from"@radix-ui/react-label";import{styled as e}from"../Theme/stitches.config.js";import"../Theme/ThemeProvider.js";const r=e(o.Root,{fontFamily:"$sans",fontSize:"$md",color:"$textPrimary"});export{r as Label};
//# sourceMappingURL=Label.js.map
